module.exports = __webpack_public_path__ + "static/media/link.551611e1.png";